import { Button, Col, Row } from 'antd';
import React, { useState } from 'react'
import { AllPeriodLimitationComponent } from '../Components/PeriodLimitation/AllPeriodLimitationComponent'
import { AddPeriodLimitationComponent } from '../Components/PeriodLimitation/AddPeriodLimitationComponent';
import { EditPeriodLimitationComponent } from '../Components/PeriodLimitation/EditPeriodLimitationComponent';
import { addButton } from '../assets/styles/stylesMain';
// ======================================================================
export const PeriodLimitation = ({ setLoading, showMessage, periodId, periodTitle, onBackClick }) => {
    // ======================================================================
    const [view, setView] = useState('All');
    const [version, setVersion] = useState(1);
    const [currentPage, setCurrentPage] = useState(1);
    const [periodLimitationId, setPeriodLimitationId] = useState(0);
    // ======================================================================
    return (
        <>
            {view === "All" ?
                <AllPeriodLimitationComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    periodId={periodId}
                    periodTitle={periodTitle}
                    version={version}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    onAddClick={() => setView("Add")}
                    onEdit={(id) => { setPeriodLimitationId(id); setView("Edit") }}
                    onRowDeleted={() => { setVersion(version + 1); setView("All"); }}
                    onBackClick={onBackClick}
                /> : <></>
            }

            {view === "Edit" ?
                <EditPeriodLimitationComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    id={periodLimitationId}
                    rowUpdated={() => { setVersion(version + 1); setView("All"); }}
                    cancelEdit={() => setView("All")}
                /> : <></>
            }
            {view === "Add" ?
                <AddPeriodLimitationComponent
                    setLoading={setLoading}
                    showMessage={showMessage}
                    periodId={periodId}
                    rowInserted={() => { setVersion(version + 1); setView("All"); }}
                    cancelInsert={() => setView("All")}
                /> : <></>
            }
        </>
    )
}
